import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

// Layout
import Header from './components/main/Header';
import Footer from "./components/main/Footer";

// Pages
import Home from "./components/pages/Home";
import Cart from './components/pages/Cart';
import ProductDetails from './components/pages/ProductDetails';
import Checkout from './components/pages/Checkout';
import Terms from './components/pages/Terms';
import ProductGrid from './components/pages/ProductGrid';
import AboutUs from './components/pages/AboutUs';
import Privacy from './components/pages/Privacy';
import CotactUs from './components/pages/ContactUs';
import CategoryPage from './components/pages/CategoryPage';
import NotFound from './components/pages/NotFound';
import ProductGridTwo from './components/pages/ProductGridTwo';
import AccessoriesDetails from './components/pages/AccessoriesDetails';
import MainCategories from './components/pages/MainCategories';
import CategoriesProducts from './components/pages/CategoriesProducts';
import Brands from './components/pages/Brands';
import BrandsProducts from './components/pages/BrandsProducts';
import SubCategories from './components/pages/SubCategories';

// Hooks
import Top from './components/Top';
import ScrollToTop from './components/ScrollToTop';
// import Loader from './components/Loader';
import UseScrollAnimation from './hooks/UseScrollAnimation';
export default function App() {
  const location = useLocation();

  const isNotFound = location.pathname === '*';
  const showFooter = location.pathname !== '/category' && !isNotFound;

  return (
    <>
      {!isNotFound && <Header />}
      {!isNotFound && <Top />}

      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/productdetails/:id' element={<ProductDetails />} />
        <Route path='/checkout' element={<Checkout />} />
        <Route path='/productgrid' element={<ProductGrid />} />
        <Route path='/productgrid/:id' element={<ProductGrid />} />
        <Route path='/terms' element={<Terms />} />
        <Route path='/privacy' element={<Privacy />} />
        <Route path='/contact' element={<CotactUs />} />
        <Route path='/about' element={<AboutUs />} />
        <Route path='/category' element={<CategoryPage />} />
        <Route path='/accessoriesdetails/:id' element={<AccessoriesDetails />} />
        <Route path='/productgridtwo/' element={<ProductGridTwo />} />
        <Route path='/mainCategories/:id' element={<MainCategories />} />
        <Route path='/categoriesProducts/:id' element={<CategoriesProducts />} />
        <Route path='/brands' element={<Brands />} />
        <Route path='/brandsProducts/:id' element={<BrandsProducts />} />
        <Route path='/subCategories/:id/:id' element={<SubCategories />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      <ScrollToTop />
      <UseScrollAnimation />

      {!isNotFound && showFooter && <Footer />}
    </>
  );
}
